<template>
  <a-card>
    <div class="cardBody">
      <a-form>
        <div v-if="fieldSettings.location_region.is_visible">
          <base-input :label="`Region`" :required="fieldSettings.location_region.is_required">
            <a-select
              id="region"
              v-model="formData.region.code"
              @change="onChangeRegion"
              show-search
              optionFilterProp="children"
            >
              <a-select-option
                v-for="region in options.regions"
                :key="region.code"
                :value="region.code"
                :data-region_code="region.regionCode"
              >
                {{ region.regionName }}
              </a-select-option>
            </a-select>
            <div v-if="$v.formData.region.code.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.region.code.required">Field is required</div>
            </div>
          </base-input>
        </div>
        <div v-if="fieldSettings.location_province.is_visible && options.provinces.length > 0">
          <base-input :label="`Province`" :required="fieldSettings.location_province.is_required">
            <a-select
              id="province"
              v-model="formData.province.code"
              @change="onChangeProvince"
              show-search
              optionFilterProp="children"
              :placeholder="'Province'"
            >
              <a-select-option
                v-for="province in options.provinces"
                :key="province.code"
                :value="province.code"
                :data-region_code="province.regionCode"
              >
                {{ province.name }}
              </a-select-option>
            </a-select>
            <div v-if="$v.formData.province.code.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.province.code.required">Field is required</div>
            </div>
          </base-input>
        </div>

        <div v-if="fieldSettings.location_city.is_visible">
          <base-input :label="`City\Municipality`" :required="fieldSettings.location_city.is_required">
            <a-select
              id="municity"
              v-model="formData.municity.code"
              @change="onChangeMuniCity"
              show-search
              optionFilterProp="children"
              placeholder="City\Municipality"
            >
              <a-select-option
                v-for="municity in options.municities"
                :data-is-city="String(municity.isCity)"
                :key="municity.code"
                :value="municity.code"
              >
                {{ municity.name }}
              </a-select-option>
            </a-select>
            <div v-if="$v.formData.municity.code.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.municity.code.required">Field is required</div>
            </div>
          </base-input>
        </div>
        <div class="row" v-if="fieldSettings.location_barangay.is_visible">
          <div class="col">
            <base-input :label="`Barangay`" :required="fieldSettings.location_barangay.is_required">
              <a-select
                id="barangay"
                v-model="formData.barangay.code"
                @change="onChangeBarangay"
                show-search
                optionFilterProp="children"
              >
                <a-select-option v-for="barangay in options.barangays" :key="barangay.code" :value="barangay.code">
                  {{ barangay.name }}
                </a-select-option>
              </a-select>
              <div v-if="$v.formData.barangay.code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.barangay.code.required">Field is required</div>
              </div>
            </base-input>
          </div>
          <div class="col" v-if="fieldSettings.zipcode.is_visible">
            <base-input :label="`Zip Code`" :required="fieldSettings.zipcode.is_required">
              <a-input v-model="formData.zipcode" placeholder="Zip Code" />
              <div v-if="$v.formData.zipcode.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.zipcode.required">Field is required</div>
                <div class="error" v-if="!$v.formData.zipcode.alphaNumSpecial">Special characters are not allowed</div>
              </div>
            </base-input>
          </div>
        </div>
        <div v-if="fieldSettings.location_street.is_visible">
          <base-input :label="`Street`" :required="fieldSettings.location_street.is_required">
            <a-input placeholder="Street" v-model="formData.street" />
            <div v-if="$v.formData.street.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.street.required">Field is required</div>
              <div class="error" v-if="!$v.formData.street.alphaNumSpecial">Special characters are not allowed</div>
            </div>
          </base-input>
        </div>
        <div v-if="fieldSettings.location_unit.is_visible">
          <base-input :label="`Unit No`" :required="fieldSettings.location_unit.is_required">
            <a-input placeholder="Unit No" v-model="formData.unit" />
            <div v-if="$v.formData.unit.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.unit.required">Field is required</div>
              <div class="error" v-if="!$v.formData.unit.alphaNumSpecial">Special characters are not allowed</div>
            </div>
          </base-input>
        </div>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import PSGCApi from '@/controllers/psgcApi';
import { requiredIf } from 'vuelidate/lib/validators';
import { getFieldSettings } from '@/utils/clpSiteSettings';

function alphaNumSpecial(value) {
  if (!value || typeof value !== 'string') return true;
  return /^[a-zA-Z0-9\s]+$/.test(value);
}

export default {
  props: {
    data: {
      type: Object,
    },
  },
  name: 'ContactInformation',
  data() {
    return {
      fieldSettings: {
        location_region: { is_visible: 0, is_required: 0, is_editable: 0 },
        location_province: { is_visible: 0, is_required: 0, is_editable: 0 },
        location_city: { is_visible: 0, is_required: 0, is_editable: 0 },
        location_barangay: { is_visible: 0, is_required: 0, is_editable: 0 },
        location_street: { is_visible: 0, is_required: 0, is_editable: 0 },
        location_unit: { is_visible: 0, is_required: 0, is_editable: 0 },
        zipcode: { is_visible: 0, is_required: 0, is_editable: 0 },
      },
      formData: {
        region: {
          value: null,
          code: null,
        },
        province: {
          value: null,
          code: null,
        },
        city: {
          value: null,
          code: null,
        },
        municipality: {
          value: null,
          code: null,
        },
        municity: {
          value: null,
          code: null,
        },
        barangay: {
          value: null,
          code: null,
        },
        street: null,
        unit: null,
        zipcode: null,
      },
      options: {
        regions: [],
        provinces: [],
        municities: [],
        barangays: [],
      },
    };
  },
  validations() {
    const validation = {
      formData: {
        region: {
          code: {
            required: requiredIf(function () {
              return this.fieldSettings.location_region.is_required === true;
            }),
          },
        },
        province: {
          code: {
            required: requiredIf(function () {
              return this.options.provinces.length > 0 && this.fieldSettings.location_province.is_required === true;
            }),
          },
        },
        municity: {
          code: {
            required: requiredIf(function () {
              return this.fieldSettings.location_city.is_required === true;
            }),
          },
        },
        barangay: {
          code: {
            required: requiredIf(function () {
              return this.fieldSettings.location_barangay.is_required === true;
            }),
          },
        },
        street: {
          required: requiredIf(function () {
            return this.fieldSettings.location_street.is_required === true;
          }),
          alphaNumSpecial,
        },
        unit: {
          required: requiredIf(function () {
            return this.fieldSettings.location_unit.is_required === true;
          }),
          alphaNumSpecial,
        },
        zipcode: {
          required: requiredIf(function () {
            return this.fieldSettings.zipcode.is_required === true;
          }),
          alphaNumSpecial,
        },
      },
    };
    return validation;
  },
  methods: {
    async populateRegion() {
      const NCR_CODE = '130000000';
      const regions = await PSGCApi.get('/regions');
      if (!Array.isArray(regions)) {
        this.options.regions = [];
        return;
      }
      this.options.regions = regions.sort((region1, region2) => {
        if (region1.code === NCR_CODE) return -1;
        if (region2.code === NCR_CODE) return 1;
        return region1.name.localeCompare(region2.name);
      });
    },
    async populateProvince(payload = null) {
      let endpoint = '/provinces';
      if (payload !== null) {
        endpoint = `/regions/${payload}/provinces`;
      }
      let data = await PSGCApi.get(endpoint);
      if (!Array.isArray(data)) {
        this.options.provinces = [];
        return;
      }
      this.options.provinces = data.sort((a, b) => a.name.localeCompare(b.name));
    },
    async getMuniCities(regionCode) {
      if (regionCode !== null) {
        let data = await PSGCApi.get('/provinces/' + regionCode + '/cities-municipalities/');

        if (!data || data.length === 0) {
          data = await PSGCApi.get('/regions/' + regionCode + '/cities-municipalities/');
        }

        this.options.municities = Array.isArray(data) ? data : [];
      }
    },
    async getBarangays(municityCode) {
      if (municityCode !== null) {
        const barangays = await PSGCApi.get('/cities-municipalities/' + municityCode + '/barangays');
        this.options.barangays = Array.isArray(barangays) ? barangays : [];
      }
    },

    getRegionByCode(regionCode) {
      return this.options.regions.find((region) => region.code === regionCode);
    },
    getProvinceByCode(provinceCode) {
      return this.options.provinces.find((province) => province.code === provinceCode);
    },
    getMuniCityByCode(municityCode) {
      return this.options.municities.find((municity) => municity.code === municityCode);
    },
    getBarangayByCode(barangayCode) {
      return this.options.barangays.find((barangay) => barangay.code === barangayCode);
    },
    getRegionName(region) {
      return region ? region.regionName || region.name || null : null;
    },

    async onChangeRegion(regionCode) {
      const selectedRegion = this.getRegionByCode(regionCode);
      this.formData.region.code = regionCode;
      this.formData.region.value = this.getRegionName(selectedRegion);
      this.formData.province.code = null;
      this.formData.province.value = null;
      this.formData.municity.code = null;
      this.formData.municity.value = null;
      this.formData.city.code = null;
      this.formData.city.value = null;
      this.formData.municipality.code = null;
      this.formData.municipality.value = null;
      this.formData.barangay.code = null;
      this.formData.barangay.value = null;
      this.formData.street = null;
      this.formData.unit = null;
      this.formData.zipcode = null;

      this.options.provinces = [];
      this.options.municities = [];
      this.options.barangays = [];

      // Always try to populate provinces first
      await this.populateProvince(regionCode);

      // If no provinces, fallback to city/municipality
      if (this.options.provinces.length === 0) {
        await this.getMuniCities(regionCode);
      }
    },

    async onChangeProvince(provinceCode) {
      const selectedProvince = this.getProvinceByCode(provinceCode);
      if (!selectedProvince) return;

      if (this.formData.region.code == null) {
        this.formData.region.code = selectedProvince.regionCode;
        const region = this.getRegionByCode(selectedProvince.regionCode);
        this.formData.region.value = this.getRegionName(region);

        await this.populateProvince(this.formData.region.code);
      }

      this.formData.province.code = provinceCode;
      this.formData.province.value = selectedProvince.name;

      this.formData.municity.code = null;
      this.formData.municity.value = null;
      this.formData.city.code = null;
      this.formData.city.value = null;
      this.formData.municipality.code = null;
      this.formData.municipality.value = null;
      this.formData.barangay.code = null;
      this.formData.barangay.value = null;
      this.formData.street = null;
      this.formData.unit = null;
      this.formData.zipcode = null;

      this.options.municities = [];
      this.options.barangays = [];

      await this.getMuniCities(this.formData.province.code);
    },
    onChangeMuniCity(municityCode) {
      const selectedMuniCity = this.getMuniCityByCode(municityCode);
      if (!selectedMuniCity) return;

      this.formData.municity.code = municityCode;
      this.formData.municity.value = selectedMuniCity.name;
      this.formData.city.value = null;
      this.formData.city.code = null;
      this.formData.municipality.value = null;
      this.formData.municipality.code = null;

      if (selectedMuniCity.isCity) {
        this.formData.city.value = selectedMuniCity.name;
        this.formData.city.code = municityCode;
      } else {
        this.formData.municipality.value = selectedMuniCity.name;
        this.formData.municipality.code = municityCode;
      }
      this.formData.barangay.value = null;
      this.formData.barangay.code = null;
      this.formData.zipcode = null;
      this.options.barangays = [];
      this.getBarangays(municityCode);
    },
    onChangeBarangay(barangayCode) {
      const selectedBarangay = this.getBarangayByCode(barangayCode);
      this.formData.barangay.code = barangayCode;
      this.formData.barangay.value = selectedBarangay ? selectedBarangay.name : null;
    },
    async populateData() {
      const data = this.data;
      this.formData.unit = data.locationUnit;
      this.formData.street = data.locationStreet;
      this.formData.barangay.value = data.locationBarangay;
      this.formData.barangay.code = data.barangayCode;
      this.formData.city.value = data.locationCity;
      this.formData.city.code = data.cityCode;
      this.formData.city.value = data.locationCity;
      this.formData.city.code = data.cityCode;
      this.formData.municipality.value = data.locationMunicipality;
      this.formData.municipality.code = data.municipalityCode;
      this.formData.province.value = data.locationProvince;
      this.formData.province.code = data.provinceCode;
      this.formData.region.value = data.locationRegion;
      this.formData.region.code = data.regionCode;
      this.formData.municity.value = data.locationMunicipality || data.locationCity;
      this.formData.municity.code = data.municipalityCode || data.cityCode;

      if (this.formData.region.code) {
        this.populateProvince(this.formData.region.code);
      }
      if (this.formData.province.code) {
        await this.getMuniCities(this.formData.province.code);
      }
      if (this.formData.municity.code) {
        this.getBarangays(this.formData.municity.code);
      }
    },
  },
  async created() {
    await this.populateProvince();
    await this.populateRegion();
    await this.populateData();
    const settings = await getFieldSettings();
    if (settings) {
      this.fieldSettings = settings;
    }
    console.log('Field Settings:', this.fieldSettings);
  },
  watch: {
    'formData.region.code': function (data) {
      if (this.formData.region.value == null) {
        const region = this.options.regions.find((region) => region.code == data);
        if (region) this.formData.region.value = region.regionName;
      }
    },
  },
};
</script>

<style></style>
